import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import styles from "./Layout.module.css";
import { useLocation } from "react-router-dom";
import authService from "../../api-authorization/AuthorizeService";
import { setToken, setUser } from "../../../../src/store/appSlice";
import { mergeClasses } from "../../../utils";

export default function Layout({ children }) {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  console.log("pathname", pathname);

  const useWideWidthLayout =
    pathname.split("/").includes("run-details") ||
    pathname.split("/").includes("health") ||
    pathname.split("/").includes("reports") ||
    pathname.split("/").includes("block-details") ||
    pathname.split("/").includes("blocks-view") ||
    pathname.split("/").includes("blocks-import") ||
    pathname.split("/").includes("device-diagnostic") ||
    pathname.endsWith("sprayers") ||
    pathname.endsWith("clients") ||
    pathname.split("/").includes("dashboard");

    const useMidWidthLayout = pathname.split("/").includes("sprayers");

  useEffect(() => {
    const fetchTokenAndUser = async () => {
      const token = await authService.getAccessToken();
      const user = await authService.getUser();

      token && dispatch(setToken(token));
      user && dispatch(setUser(user));
    };

    fetchTokenAndUser();
  }, []);

  return (
    <div className={styles.applayout}>
      <div
        className={mergeClasses(
          styles.container,
          useWideWidthLayout ? styles.wideContainer : useMidWidthLayout ? styles.midContainer : ""
        )}
      >
        {children}
      </div>
    </div>
  );
}
